<ng-container *ngIf="hasNews$ | async">
  <div class="notifications">
    <nz-alert *ngFor="let msg of news$ | async" nzBanner [nzType]="msg.type" [nzMessage]="msg.message"></nz-alert>
  </div>
</ng-container>
